<div>

    <div class="row m-0 p-0">

        <div class="col-md-12">
            <div class="closebtn1" (click)="close()">
                <span class="material-icons">
                    close
                </span>
            </div>
            <div class="row align-items-center justify-content-between">
                <div class="col-md-12 ">

                    <form [formGroup]="callBackForm">
                        <div class="form_full_course">
        
                           <h3>Get Counselling</h3>

                            <!-- <h3>Select your Target Year</h3> -->
        
                            <!-- <div class="cat_chips" *ngIf="!data">
                                <mat-chip-listbox [multiple]="false" formControlName="course" multiple aria-label="Fish selection">
                                    <mat-chip-option>2025</mat-chip-option>
                                    <mat-chip-option>2026</mat-chip-option>
                                    <mat-chip-option>2027</mat-chip-option>
                                 
                                  </mat-chip-listbox>
                            </div> -->
                          

                            <div class="cat_chips mb-4" *ngIf="data == 'Cat Crash Course'">
                                <mat-chip-listbox formControlName="course" aria-label="Select Course">
                                    <mat-chip-option>CAT Crash Course</mat-chip-option>
                                   
                                </mat-chip-listbox>
                            </div>

                            <div class="cat_chips mb-4" *ngIf="data == 'CAT 2024'">
                                <mat-chip-listbox formControlName="course" aria-label="Select Course">
                                    <mat-chip-option> CAT 2024</mat-chip-option>
                                </mat-chip-listbox>
                            </div>

        
                            <div class="enq_filds">
                            
                                <mat-form-field class="example-full-width">
                                    <input type="text" matInput formControlName="name" placeholder="Enter name">                                    
                                   
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                

                                <mat-form-field class="example-full-width">
                                    <input type="email" matInput formControlName="email" placeholder="Enter email">                                    
                                   
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                

                                <mat-form-field class="example-full-width">
                                    <input type="tel" minlength="10" maxlength="10" autocomplete="off" matInput formControlName="phone" placeholder="Enter phone number">                                    
                                   
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                            
                                <mat-form-field class="example-full-width" *ngIf="data">
                                    <input type="text" matInput readonly formControlName="course" placeholder="College">                                    
                                </mat-form-field>
                                <mat-form-field class="example-full-width" *ngIf="!data">
                                   <mat-select formControlName="course" placeholder="College">
                                    <mat-option *ngFor="let college of bschoolsList" [value]="college.Name">{{college.Name}}</mat-option>
                                   </mat-select>                                   
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <mat-label>State</mat-label>
                                    <mat-select formControlName="state" (selectionChange)="getCities()">
                                        <mat-option *ngFor="let state of stateList" [value]="state.name">{{state.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="enq_filds">
                                <mat-form-field class="example-full-width">
                                    <mat-label>City</mat-label>
                                    <mat-select formControlName="city">
                                        <mat-option *ngFor="let city of cityList" [value]="city.name">{{city.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                            <button  class="submit_button" [disabled]="submittedBtn" mat-flat-button (click)="callback()"><img src="https://media.iquanta.in/ui_images/new-dashboard/power-icon.png" alt=""> Submit</button>
        
                        </div>
                    </form>
                </div>

                <!-- <div class="col-md-5">
                    <div class=" dilog_mobile college-image">
                        <img src="https://media.iquanta.in/ui_images/new-dashboard/college-img.jpg" alt="">
                    </div>
                 
                </div> -->
            </div>
           

        </div>

    </div>

</div>